export const MEDIUM = 'md';
export const MEDIUM_SMALL = 'ms';
export const EXTRA_SMALL = 'xs';
export const SMALL = 'sm';
export const EXTRA_EXTRA_SMALL = 'xxs';
export const LARGE = 'lg';
export const EXTRA_LARGE = 'xl';